export const ForgotUsernameResources = {
  ForgotUsernameHeader: "Let's find your account",
  ForgotUsernameDescription: "Enter the information below. We'll send your username or a verification code to the email address on file.",
  NewUserHeader: "Setup your online account",
  NewUserDescription: "Enter the information below to start your online account setup. If your online account already exists, we will send your username to the email address on file."
};
